import React from "react";

const ListeningAbilityIcon = (props) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="37"
      height="37"
      rx="18.5"
      stroke="currentColor"
      fill="none"
    />
    <g clipPath="url(#clip0_4466_7036)">
      <path
        d="M11.2852 17.0713V20.9284"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1426 13.8564V24.1422"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 10.6426V27.3569"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8574 13.8564V24.1422"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.7129 17.0713V20.9284"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4466_7036">
        <rect width="18" height="18" fill="white" transform="translate(10 10)" />
      </clipPath>
    </defs>
  </svg>
);

export default ListeningAbilityIcon;